import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import styled from "styled-components";
import {
  successStrong,
  errorStrong,
  undeterminedStrong,
} from "../styles/colors";
import {
  loadDashboard,
  changeArchive,
  setArchiveSetting,
  setProgressSearchTerm,
  setProgressFrom,
  setProgressTo,
  setProgressInside,
  setProgressBorderline,
  setProgressOutside,
  saveEngagement,
} from "../store/assessment/actions";
import {
  getDashboardData,
  getDashboardLoading,
  getArchiveSetting,
  getProgressSearchTerm,
  getProgressFrom,
  getProgressTo,
  getProgressInside,
  getProgressBorderline,
  getProgressOutside,
} from "../store/assessment/selectors";
import {
  getCompanyType,
  getHasFeature,
  getUserCompany,
} from "../store/users/selectors";
import {
  faAsterisk,
  faBalanceScaleLeft,
  faCheck,
  faClock,
  faEye,
  faFileAlt,
  faPaperPlane,
  faArrowRight,
  faUserFriends,
  faClone,
  faArchive,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { loadClients, setCurrentClient } from "../store/clients/actions";
import { getClients, getCurrentClient } from "../store/clients/selectors";
import { TitleArea } from "../components/Elements";
import Loader from "../components/Loader";
import { generateClientOptions } from "./Contractors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getDisplayName, getRiskClassName } from "../components/ResultScreen";
import FormField from "../components/FormField";
import Combo from "../components/Combo";

export const statuses = {
  STARTED: {
    name: "Started",
    icon: faAsterisk,
  },
  AWAITING_CONTRACTOR: {
    name: "Awaiting Contractor",
    icon: faClock,
  },
  AWAITING_REVIEW: {
    name: "Awaiting Review",
    icon: faEye,
  },
  AWAITING_DISTRIBUTION: {
    name: "SDS Ready to send",
    icon: faPaperPlane,
  },
  AWAITING_SDS_ACCEPTANCE: {
    name: "Waiting for SDS",
    icon: faFileAlt,
  },
  IN_DISPUTE: {
    name: "In Dispute",
    icon: faBalanceScaleLeft,
  },
  COMPLETE: {
    name: "Complete",
    icon: faCheck,
  },
};

const ClientSelector = styled.select`
  margin-top: 20px;
  margin-left: 30px;
  height: 39px;
  font-size: 16px;
  outline: none;
  border: 1px solid #ccc;
`;

const ColumnsWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  position: relative;
  flex: 1;
  .hint {
    transition: opacity 150ms ease-in;
    opacity: 0;
    @media (max-width: 1980px) {
      opacity: 1;
    }
    position: absolute;
    top: -40px;
    right: 40px;
  }
`;

const Columns = styled.div`
  display: flex;
  box-sizing: border-box;
  flex: 1;
  gap: 16px;
  margin: 20px 24px 24px;
  max-height: 100%;
  overflow: auto;
  position: relative;
  transition: opacity 300ms ease-in;
  

  ${(props) => (props.loading ? "opacity: 0.4" : "opacity: 1")}
  
`;

const Column = styled.div`
  align-self: flex-start;
  flex: 1;
  padding: 12px;
  min-width: 275px;
  background-color: var(--app-surface-soft);
  border: 1px solid var(--app-border);
  border-radius: 8px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 430px);
  transition: height 200ms ease-in;

  &:first-child {
    margin-left: 0px;
  }

  &:last-child {
    margin-right: 0px;
  }

  h2 {
    margin: 0;
    font-size: 16px;
    padding: 4px 2px 12px;
    color: var(--app-ink);
    margin-bottom: 8px;
    position: relative;
    padding-right: 25px;
    font-weight: 800;
  }

  .card-area {
    overflow: auto;
  }
`;

const Main = styled.div`
  display: flex;
  height: 100%;
`;

const Wrap = styled.div`
  flex-direction: column;
  width: 100%;
  display: flex;
`;

const Card = styled.div`
  position: relative;
  border-radius: 8px;
  background-color: #fff;
  padding: 12px;
  margin-bottom: 10px;
  color: var(--app-ink);
  display: flex;
  border: 1px solid var(--app-border);
  box-shadow: 0 10px 18px -18px rgba(6, 40, 59, 0.45);

  .left {
    width: 32px;
    font-size: 18px;
    color: var(--app-muted);
  }

  .right {
    flex: 1;
  }

  .reference {
    font-size: 12px;
    color: var(--app-muted);
    padding-right: 68px;
  }

  h3 {
    margin: 0;
    font-size: 16px;
    color: var(--app-ink);
    ${(props) => (props.archived ? "color: #ccc;" : "")}
    margin-top: 4px;
    margin-bottom: 7px;
    line-height: 20px;
  }
  cursor: pointer;
  transition: border-color 160ms ease-in, box-shadow 160ms ease-in, transform 160ms ease-in;

  &:hover {
    border-color: #bfd2d8;
    box-shadow: 0 14px 28px -22px rgba(6, 40, 59, 0.7);
    transform: translateY(-1px);
  }

  ${(props) => (props.flag ? "background-color: #fffaf0;" : "")}
  ${(props) => (props.archived ? "color: #ccc;" : "")}
`;

const EmojiIconFloat = styled.div`
  position: absolute;
  top: 10px;
  right: 5px;
  font-size: 16px;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 5px;

  &.flag {
    color: #b49229;
  }
`;

const FlagText = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  color: #b49229;
`;

const Archive = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  color: var(--app-muted);
  font-size: 11px;
  text-transform: uppercase;
  background-color: #f0f4f5;
  padding: 3px 5px;
  border-radius: 4px;

  transition: background-color 100ms ease-in, color 100ms ease-in;

  &:hover {
    background-color: var(--app-ink);
    color: #fff;
  }
`;

const Delete = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  color: var(--app-muted);
  font-size: 12px;
  text-transform: uppercase;
  background-color: #f0f4f5;
  padding: 3px 5px;
  border-radius: 4px;

  transition: background-color 100ms ease-in, color 100ms ease-in;

  &:hover {
    background-color: var(--app-ink);
    color: #fff;
  }
`;

const ArchiveIcon = styled(FontAwesomeIcon)`
  margin-left: 3px;
`;

const DeleteIcon = styled(FontAwesomeIcon)``;

const Filter = styled.div`
  margin: 20px 30px 0px;

  h2 {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const Result = styled.div`
  --result-color: #888;

  &.pass {
    --result-color: ${successStrong};
  }

  &.fail {
    --result-color: ${errorStrong};
  }

  &.undetermined {
    --result-color: ${undeterminedStrong};
  }

  &.generic {
    --result-color: #62727b;
  }

  align-items: center;
  background-color: #fff;
  border: 1px solid #d7e2e5;
  border-radius: 999px;
  color: var(--app-ink);
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  gap: 6px;
  line-height: 16px;
  margin-right: 4px;
  padding: 3px 8px 3px 6px;
  text-transform: uppercase;

  &:before {
    background-color: var(--result-color);
    border-radius: 50%;
    content: "";
    display: block;
    height: 9px;
    width: 9px;
  }
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

const FilterItem = styled.div`
  background-color: var(--app-surface-soft);
  border: 1px solid var(--app-border);
  padding: 10px;
  box-sizing: border-box;
  border-radius: 6px;
  margin-right: 10px;

  &.search {
    flex-basis: 400px;
  }
`;

const StyledCombo = styled(Combo)`
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 30px;
`;

function Dashboard({ history }) {
  const dispatch = useDispatch();

  const dashboardData = useSelector(getDashboardData);
  const userCompany = useSelector(getUserCompany);
  const currentClient = useSelector(getCurrentClient);
  const company = useSelector(getUserCompany);
  const dashboardLoading = useSelector(getDashboardLoading);

  const archiveSetting = useSelector(getArchiveSetting);

  const searchTerm = useSelector(getProgressSearchTerm);

  const setSearchTerm = (term) => {
    dispatch(setProgressSearchTerm(term));
  };

  const [reportingDataToRender, setReportingDataToRender] = useState([]);

  const showInside = useSelector(getProgressInside);

  const setShowInside = (setting) => {
    dispatch(setProgressInside(setting));
  };

  const showBorderline = useSelector(getProgressBorderline);

  const setShowBorderline = (setting) => {
    dispatch(setProgressBorderline(setting));
  };
  const showOutside = useSelector(getProgressOutside);

  const setShowOutside = (setting) => {
    dispatch(setProgressOutside(setting));
  };

  const fromDate = useSelector(getProgressFrom);

  const setFromDate = (setting) => {
    dispatch(setProgressFrom(setting));
  };

  const toDate = useSelector(getProgressTo);

  const setToDate = (setting) => {
    dispatch(setProgressTo(setting));
  };

  const reports = dashboardData && dashboardData.reports;

  const clients = useSelector(getClients);
  let clientOptions = [];
  if (clients) {
    clientOptions = generateClientOptions(clients, userCompany);
  }

  useEffect(() => {
    dispatch(loadClients());
  }, []);

  useEffect(() => {
    if (userCompany && !currentClient) {
      dispatch(setCurrentClient(userCompany.id));
    }
  }, [userCompany]);

  useEffect(() => {
    console.log("TELLING TO LOAD");
    dispatch(
      loadDashboard(
        currentClient === 0 ? company.id : currentClient,
        archiveSetting
      )
    );
  }, [currentClient, archiveSetting]);


  const deleteAssessment = (engagement_id) => {
    const options = {
      title: "Are you sure?",
      message:
        "Are you sure you want to delete this engagement? This cannot be reversed!",
      buttons: [
        {
          label: "Cancel",
        },
        {
          label: "Confirm",
          onClick: async () => {
            await dispatch(
              saveEngagement({
                id: engagement_id,
                hidden: true,
              })
            );
            await dispatch(
              loadDashboard(
                currentClient === 0 ? company.id : currentClient,
                archiveSetting
              )
            );
          },
        },
      ],
    };
    confirmAlert(options);
  };

  useEffect(() => {
    const searchTermLower = searchTerm ? searchTerm.toLowerCase() : null;

    if (reports) {
      setReportingDataToRender(
        reports.filter((report) => {
          if (!report) {
            return false;
          }

          const contractorName = report.contractor_name || "";
          const nameMatch =
            !searchTermLower ||
            contractorName.toLowerCase().indexOf(searchTermLower) > -1;

          let test = true;

          if (searchTerm) {
            test = test && nameMatch;
          }

          const isInside =
            report.result === "BAD_FAIL" || report.result === "FAIL";

          if (showInside && isInside) {
            test = test && isInside;
          }

          if (!showInside && isInside) {
            test = test && !isInside;
          }

          const isBorderline = report.result === "BORDERLINE";

          if (showBorderline && isBorderline) {
            test = test && isBorderline;
          }

          if (!showBorderline && isBorderline) {
            test = test && !isBorderline;
          }

          const isOutside =
            report.result === "PASS" || report.result === "GOOD_PASS";

          if (showOutside && isOutside) {
            test = test && isOutside;
          }

          if (!showOutside && isOutside) {
            test = test && !isOutside;
          }

          if (fromDate) {
            test = test && new Date(report.datetime) >= new Date(fromDate);
          }

          if (toDate) {
            test = test && new Date(report.datetime) <= new Date(toDate);
          }

          return test;
        })
      );
    }
  }, [
    searchTerm,
    reports,
    showInside,
    showBorderline,
    showOutside,
    fromDate,
    toDate,
  ]);

  const sortOldestFirst = (x, y) => {
    const dateX = new Date(x.datetime || 0);
    const dateY = new Date(y.datetime || 0);

    if (dateX < dateY) {
      return -1;
    }
    if (dateX > dateY) {
      return 1;
    }
    return 0;
  };

  const getByStatus = (status) => {
    const filtered = reportingDataToRender
      ? reportingDataToRender.filter((report) => report.status === status)
      : [];

    if (status === "IN_DISPUTE") {
      return filtered.sort((x, y) => {
        if (x.flag && !y.flag) {
          return -1;
        }
        if (!x.flag && y.flag) {
          return 1;
        }
        return sortOldestFirst(x, y);
      });
    }
    if (status === "COMPLETE") {
      return filtered.sort((x, y) => {
        if (x.archived && !y.archived) {
          return 1;
        }
        if (!x.archived && y.archived) {
          return -1;
        }
        return sortOldestFirst(x, y);
      });
    }
    return filtered.sort(sortOldestFirst);
  };

  return (
    <Main>
      {!dashboardData ? (
        <Loader />
      ) : (
        <Wrap>
          <div>
            <TitleArea>
              <div className="title">
                <h1>Progress</h1>
              </div>
            </TitleArea>
            {clients && clients.length ? (
              <StyledCombo
                options={clientOptions}
                value={currentClient}
                onChange={(newValue) => {
                  dispatch(setCurrentClient(newValue));
                }}
              />
            ) : null}
            <Filter>
              <FormRow>
                <FilterItem className="search">
                  <FormField
                    placeholder="Search"
                    type="text"
                    changeMonitor={(value) => setSearchTerm(value)}
                    className="search"
                    value={searchTerm}
                    label="Search by keyword"
                  />
                </FilterItem>
                <FilterItem>
                  <FormField
                    placeholder="From"
                    type="date"
                    changeMonitor={(value) => setFromDate(value)}
                    value={fromDate}
                    label="From"
                  />
                </FilterItem>
                <FilterItem>
                  <FormField
                    placeholder="To"
                    type="date"
                    changeMonitor={(value) => setToDate(value)}
                    value={toDate}
                    label="To"
                  />
                </FilterItem>
              </FormRow>
              <FormRow>
                <FilterItem>
                  <input
                    type="checkbox"
                    id="show-archived"
                    defaultChecked={archiveSetting}
                    value={archiveSetting}
                    onChange={(e) =>
                      dispatch(setArchiveSetting(e.target.checked))
                    }
                  />
                  <label for="show-archived">Show Archived</label>
                </FilterItem>
                <FilterItem>
                  <input
                    type="checkbox"
                    id="inside"
                    defaultChecked={showInside}
                    value={showInside}
                    onChange={(e) => setShowInside(e.target.checked)}
                  />
                  <label for="inside">Show Inside IR35</label>
                </FilterItem>
                <FilterItem>
                  <input
                    type="checkbox"
                    id="borderline"
                    defaultChecked={showBorderline}
                    value={showBorderline}
                    onChange={(e) => setShowBorderline(e.target.checked)}
                  />
                  <label for="borderline">Show Borderline</label>
                </FilterItem>
                <FilterItem>
                  <input
                    type="checkbox"
                    id="outside"
                    defaultChecked={showOutside}
                    value={showOutside}
                    onChange={(e) => setShowOutside(e.target.checked)}
                  />
                  <label for="outside">Show Outside IR35</label>
                </FilterItem>
              </FormRow>
            </Filter>
          </div>
          <ColumnsWrapper>
            <div className="hint">
              Scroll for more <StyledFontAwesomeIcon icon={faArrowRight} />
            </div>
            <Columns loading={dashboardLoading}>
              {Object.keys(statuses).map((key) => (
                <Column>
                  <h2>
                    <EmojiIconFloat>
                      <StyledFontAwesomeIcon icon={statuses[key].icon} />
                    </EmojiIconFloat>
                    {statuses[key].name}
                  </h2>
                  <div className="card-area">
                    {getByStatus(key).map((record) => (
                      <Card
                        flag={record.flag}
                        className={[
                          record.contractor_id === -1 ? "role" : "contractor",
                          getRiskClassName(record.result),
                        ]}
                        archived={record.archived}
                        onClick={() => {
                          history.push(
                            `/main/contractors/assessment/${
                              record.company_id
                            }/${
                              record.contractor_id === -1
                                ? "rolebased"
                                : record.contractor_id
                            }/${record.engagement_id}`
                          );
                        }}
                      >
                        <Archive
                          onClick={(e) => {
                            e.stopPropagation();
                            dispatch(
                              changeArchive(record.id, !record.archived)
                            );
                          }}
                        >
                          {record.archived ? "Unarchive" : "Archive"}
                          <ArchiveIcon icon={faArchive} />
                        </Archive>

                        {(key === "STARTED" ||
                          key === "AWAITING_CONTRACTOR") && (
                          <Delete
                            onClick={(e) => {
                              e.stopPropagation();

                              deleteAssessment(record.engagement_id);
                            }}
                          >
                            <DeleteIcon icon={faTrashAlt} />
                          </Delete>
                        )}

                        <div className="left">
                          <StyledFontAwesomeIcon
                            className={record.flag ? "flag" : ""}
                            icon={
                              record.contractor_id === -1
                                ? faClone
                                : faUserFriends
                            }
                          />
                        </div>
                        <div className="right">
                          <div className="reference">
                            <StyledFontAwesomeIcon icon={statuses[key].icon} />
                            {record.reference}
                          </div>
                          <h3 className={record.flag ? "flag" : ""}>
                            {record.contractor_name}
                          </h3>
                          {record.flag && (
                            <FlagText>Dispute response required soon</FlagText>
                          )}
                          {record.result && (
                            <Result className={getRiskClassName(record.result)}>
                              {getDisplayName(
                                record.result,
                                record.validation ? "SHORT" : "FULL"
                              )}
                            </Result>
                          )}
                          {record.validation && (
                            <Result className="generic">Validation</Result>
                          )}
                        </div>
                      </Card>
                    ))}
                  </div>
                </Column>
              ))}
            </Columns>
          </ColumnsWrapper>
        </Wrap>
      )}
    </Main>
  );
}

export default withRouter(Dashboard);
